// extracted by mini-css-extract-plugin
export default {"wrapper":"ChannelFilter__wrapper___hGZ5b","title":"ChannelFilter__title___9cevF","description":"ChannelFilter__description___6K5QB"};